import { Component, OnInit } from '@angular/core';
import { ModalController, IonList, IonListHeader, IonLabel, IonItem, IonSpinner } from '@ionic/angular/standalone';
import { IonHeader, IonToolbar, IonButton, IonTitle, IonContent, IonIcon } from '@ionic/angular/standalone';
import { DisplayService } from "@qid/core";
import { Store } from "@ngrx/store";
import { Industry, IndustryService } from "../../modules/industry";
import { Organisation, OrganisationService } from "../../modules/organisation";
import { UserService } from "../../modules/user";
import { OrganisationUserActions } from "../../modules/organisation-user";
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SexyModule } from '@qid/sexy';
import { SuperButtonComponent, SuperInputComponent } from '@qid/super';

@Component({
  selector: 'qid-create-organisation',
  templateUrl: './create-organisation.page.html',
  styleUrls: ['./create-organisation.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SexyModule,
    SuperButtonComponent,
    IonHeader,
    IonToolbar,
    IonButton,
    IonTitle,
    IonContent,
    IonIcon,
    IonList,
    IonListHeader,
    IonLabel,
    IonItem,
    IonSpinner
  ],
})
export class CreateOrganisationPage implements OnInit {
  orgName: string = '';
  isMandatory: boolean = false;
  industries: Industry[] = [];
  subIndustries: Industry[] = [];
  activeSlide = 1;
  isCreatingOrg: boolean = false;
  creatingIndustryId: string | null = null;

  constructor(
    private modalController: ModalController,
    private organisationService: OrganisationService,
    private displayService: DisplayService,
    private industryService: IndustryService,
    private store: Store,
    private userService: UserService
  ) {
  }

  ngOnInit() {
    this.fetchIndustries();
  }

  async fetchIndustries() {
    this.industries = await this.industryService.readAll(null);
  }

  createOrg = async industryId => {
    try {
      this.isCreatingOrg = true;
      this.creatingIndustryId = industryId;
      await this.organisationService.create({
        name: this.orgName,
        industry: industryId,
      }).then((org) => {
        this.creatingIndustryId = null;
        this.isCreatingOrg = false;
        this.userService.setUserDefaultOrganisation(org._id);
        this.store.dispatch(OrganisationUserActions.fetchUserOrganisations())
        this.cancel(org);
      }).catch(() => {
        throw new Error(
          'Some error occurred while creating Organisation. Try again.'
        );
      })
    } catch (e) {
      this.isCreatingOrg = false;
      this.creatingIndustryId = null;
      this.displayService.alert(e);
    }
  };

  async onIndustrySelected(industryId: string) {
    this.subIndustries = await this.industryService.readAll(industryId);
    if (!this.subIndustries || this.subIndustries.length < 1) {
      return this.createOrg(industryId);
    }
    this.goToSlide(3);
  }

  cancel(org: Organisation = null) {
    this.modalController.dismiss({ org: org });
  }

  goToSlide(number: number) {
    this.activeSlide = number;
  }

  goToPreviousSlide() {
    if (this.activeSlide > 1) {
      this.goToSlide(this.activeSlide - 1);
    }
  }

  onName = () => {
    if (this.orgName.length < 1) {
      this.displayService.toast({ message: 'Please set a business name' });
      return null
    }
    this.goToSlide(2);
  }
}
